'use client';

import { Modal } from 'react-bootstrap';
import styles from './cart-success-sheet.module.scss';

interface CartSuccessSheetProps {
  show: boolean;
  children: React.ReactNode;
  onClose: () => void;
}


const CartSuccessSheet = ({
  show,
  children,
  onClose
}: CartSuccessSheetProps) => {
  
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName={styles.cartSuccessSheet}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Body className={styles.content}>
        {children}
      </Modal.Body>
    </Modal>
  );
};

export default CartSuccessSheet;
